import React from 'react';
import {useFilter} from '@unthinkable/react-filters';
import {AutoCompleteFilter} from 'src/components/filter/Filters';
import {TableHeader} from 'src/components/header/TableHeader';
import {Table} from 'src/components/table';
import Config from 'src/Config';
import {routeLink} from 'src/constant';

const CCDLog = () => {
  const {onChangeFilter, filterValues} = useFilter();

  const options = [
    {
      label: 'Pending',
      value: 'Pending',
    },
    {
      label: 'Failed',
      value: 'Failed',
    },
    {
      label: 'Successful',
      value: 'Successful',
    },
  ];
  return (
    <Table
      renderHeader={() => {
        return (
          <TableHeader
            actions={[
              <AutoCompleteFilter
                onChangeFilter={onChangeFilter}
                filterValues={filterValues}
                field={'status'}
                suggestionField={'label'}
                keyField={'value'}
                options={options}
                key={'statusFilter'}
                placeholder={'Status'}
              />,
            ]}
          />
        );
      }}
      limit={Config.defaultListLimit}
      api={routeLink.ccdLogs}
      addOnFilter={JSON.stringify(filterValues.filter)}
      sort={{
        createdAt: -1,
      }}
      fields={{
        fileName: 1,
        status: 1,
        reason: 1,
        createdAt: 1,
      }}
      columns={[
        {
          header: 'FileName',
          field: 'fileName',
          type: 'text',
        },
        {
          header: 'Status',
          field: 'status',
          type: 'text',
        },
        {
          header: 'Reason',
          field: 'reason',
          type: 'text',
        },
        {
          header: 'Uploaded At',
          field: 'createdAt',
          type: 'date',
          formatOptions: {
            format: Config.dateFormat,
          },
        },
      ]}
    />
  );
};
export default CCDLog;
